import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FarmNote } from '../models/farm-note';

@Injectable({ providedIn: 'root' })
export class FarmNoteService {
  private basePath = environment.PLATFORM_API_URL;

  constructor(private http: HttpClient) { }

  getByFarm(farmId: number): Observable<FarmNote[]> {
    return this.http.get<FarmNote[]>(`${this.basePath}/api/farm-notes/by-farm/${farmId}`);
  }

  create(note: FarmNote): Observable<FarmNote> {
    return this.http.post<FarmNote>(`${this.basePath}/api/farm-notes`, note);
  }

  update(note: FarmNote): Observable<FarmNote> {
    return this.http.put<FarmNote>(`${this.basePath}/api/farm-notes/${note.id}`, note);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/api/farm-notes/${id}`);
  }
}
